import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function FileDashboardRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.FileDashboard', {
		url: '/admin/files/dashboard',
		controllerAs: 'vm',
		controller: FileDashboardCtrl,
		templateUrl: '/ng/hub/File/Dashboard/FileDashboardCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'File Dashboard',
		},
	});
}
export class FileDashboardCtrl {
	constructor($filter) {
		'ngInject';
		this.dateFormat = $filter('shDate');
		this.truncate = $filter('shCharacters');
		this.table = {
			endpoint: '/file_processing/dashboard',
			defaultSort: '-service_start_date',
			columns: [
				{ field: 'filename', label: 'Filename', sortable: true },
				{ field: 'service_name', label: 'Service Name', sortable: false },
				{ field: 'service_start_date', label: 'Start Date', sortable: true },
				{ field: 'service_end_date', label: 'End Date', sortable: true },
				{
					field: 'service_elapsed',
					label: 'Service Elapsed Time (in seconds)',
					sortable: false,
				},
				{ field: 'service_status', label: 'Service Status', sortable: false },
				{ field: 'service_result', label: 'Service Result', sortable: false },
				{ field: 'api_status', label: 'API Status', sortable: false },
				{ field: 'api_result', label: 'API Result', sortable: false },
				{ field: 'api_elapsed', label: 'API Elapsed Time (in seconds)', sortable: false },
			],
			filters: {},
			transformer: this.transform.bind(this),
			bindUrl: 'search',
		};
	}

	transform(result) {
		// format the date fields
		result.data.forEach(file => {
			file.service_start_date = this.dateFormat(file.service_start_date, 'long');
			file.service_end_date = this.dateFormat(file.service_end_date, 'long');
			file.service_result = this.truncate(file.service_result, 25, false);
		});
		return result;
	}

	clearSearch() {
		Object.keys(this.table.filters).forEach(field => {
			this.table.filters[field] = undefined;
		});
	}
}
